import { api, resolvePagination } from './api';

export const getPatientNotes = async (patient, token, signal) => {
    const response = await api.get('/cheart/notes', {
        signal,
        headers: {
            ...resolvePagination(token, 3),
            'CHEART-QUERY-PATIENT': patient,
            'CHEART-QUERY-ORDER': 'DESC'
        }
    });
    return {
        notes: response.data,
        nextToken: response.headers['pagination-token'] || null,
        count: Number(response.headers['pagination-count']) || 0
    };
};

export const fetchClinicalNote = async (note, signal) => {
    const response = await api.post('/cheart/notes/fetch', { note }, { signal });
    return response.data;
};

export const createClinicalNote = async ({ patient, content }) => {
    const response = await api.post('/cheart/notes', {
        patient,
        ts: new Date().toISOString(),
        format: 'PLAIN',
        content,
        priviledged: false
    });
    return response.data;
};
